const CameraTweenTrack = new class CameraTweenTrack {
    constructor() {
        this.activeTimeline = null;
    }

    killTweens() {
        if (this.activeTimeline) this.activeTimeline.kill();

        this.activeTimeline = null;

        TweenMax.killTweensOf(Q3.RenderManager.activeCamera);
    }

    finishTweens() {
        if (this.activeTimeline)
            this.activeTimeline.totalTime(this.activeTimeline.totalDuration());

        this.activeTimeline = null;

        Q3.labels.live.update();
    }
}

export default CameraTweenTrack;
export { CameraTweenTrack };

